const getErrorsList = errorObject => {
  const validationObj = Object.keys(errorObject).map(key =>
    Object.keys(errorObject[key].errors).map(i => errorObject[key].errors[i].message)
  );

  return [].concat(...validationObj);
};

export default getErrorsList;
